<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
import { useLighthouse } from '~/composables/common/use-lighthouse'

const JackpotSection = defineAsyncComponent(async () => await import('./jackpot-section.vue'))
const GamesHotSection = defineAsyncComponent(async () => await import('./games-hot-section.vue'))
const LiveStream = defineAsyncComponent(async () => import('~/components/common/casino/live-stream.vue'))
const { isLighthouseBot } = useLighthouse()
</script>

<template>
  <div class="home-page">
    <div class="container">
      <LiveStream v-if="!isLighthouseBot" class="mt-0" />
      <JackpotSection />
      <GamesHotSection />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/mobile/pages/home/index.scss';
</style>
